import { render, staticRenderFns } from "./Modules.vue?vue&type=template&id=4abec7b5&scoped=true"
import script from "./Modules.vue?vue&type=script&lang=ts"
export * from "./Modules.vue?vue&type=script&lang=ts"
import style0 from "./Modules.vue?vue&type=style&index=0&id=4abec7b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abec7b5",
  null
  
)

export default component.exports